<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="cont" title="Contents">
<p class="h2f"><span class="right_1" epub:type="pagebreak" id="page_v" title="v">CONTENTS</span></p>
<p class="tocf0" id="ack"><span class="hide">       </span><a href="#/text/9780253041203_Acknowledgments"><i>Acknowledgments</i></a></p>
<p class="tocf" id="tra"><span class="hide">       </span><a href="#/text/9780253041203_Transliteration"><i>Note on Transliteration</i></a></p>
<p class="tocf1" id="int"><span class="hide">       </span><a href="#/text/9780253041203_Introduction">Introduction</a></p>
<p class="toc" id="ch1"><span href="#/text/9780253041203_Chapter_1" title="Link target outside of Sample">1<span class="spacec"><span class="hide">     </span>Performing <i>à la Russe</i>: Music, Migration, and the White Russians in 1920s Harlem</span></span></p>
<p class="toc" id="ch2"><span href="#/text/9780253041203_Chapter_2" title="Link target outside of Sample">2<span class="spacec"><span class="hide">     </span>New York’s Russian Vogue: The Fox-Trotsky and Other Musical Delights</span></span></p>
<p class="toc" id="ch3"><span href="#/text/9780253041203_Chapter_3" title="Link target outside of Sample">3<span class="spacec"><span class="hide">     </span>Emigration at the Boundary: Russian DPs, Second Generation Émigrés, and Soviet Song in the World War II Era</span></span></p>
<p class="toc" id="ch4"><span href="#/text/9780253041203_Chapter_4" title="Link target outside of Sample">4<span class="spacec"><span class="hide">     </span>Radio Liberty, Vernon Duke, and the “Internal” Émigré Voice in Cold War Broadcasting</span></span></p>
<p class="toc" id="ch5"><span href="#/text/9780253041203_Chapter_5" title="Link target outside of Sample">5<span class="spacec"><span class="hide">     </span>Old Russia at the Pierre: Music, Enchantment, and the Dancing Body in Twenty-First Century New York</span></span></p>
<p class="tocf" id="epi"><span class="hide">       </span><span href="#/text/9780253041203_Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="tocf1" id="bib"><span class="hide">       </span><span href="#/text/9780253041203_Bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="tocf" id="ind"><span class="hide">       </span><span href="#/text/9780253041203_Index" title="Link target outside of Sample"><i>Index</i></span><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253041203_Contents.vue?5cf609b6